export const storePreviousPagePath = (previousPagePath: string | undefined) => {
  window.sessionStorage.setItem('previousPagePath', previousPagePath || '');
};
